import Autocomplete from "@tomickigrzegorz/autocomplete";
import geocoder from "../geocoder";
import { defaults, escape } from "../autocomplete";

const MAXIMUM_LOCATIONS = 10;

const isSameLocation = (a, b) =>
  (a.mapbox_id && a.mapbox_id === b.mapbox_id) || (a.id && a.id === b.id);

export default (locations = []) => ({
  locations: locations,
  error: null,

  init() {
    const geocode = geocoder(false);

    this.autocomplete = new Autocomplete(this.$refs.input.id, {
      ...defaults("location"),
      onSearch: async ({ currentValue }) => {
        this.abortController?.abort();

        this.abortController = new AbortController();
        this.error = null;

        try {
          const locations = await geocode(
            currentValue,
            {
              includeAddresses: false,
              includeStates: true,
            },
            this.abortController.signal,
          );

          return locations;
        } catch (error) {
          if (error.name === "AbortError") {
            return [];
          }

          console.error(error);
          this.error = error.message;
          return [];
        }
      },

      noResults: ({ template }) => {
        if (!this.error) {
          return template(
            `<div class="px-4 py-2 text-gray-600">No locations match your query.</div>`,
          );
        }

        return template(
          `<div class="px-4 py-2 text-gray-600">Something went wrong loading suggestions (${escape(this.error)}). Please try a different browser or disable browser extensions.</div>`,
        );
      },

      onSubmit: async ({ object }) => {
        if (!this.locations.some((location) => isSameLocation(location, object))) {
          this.locations.push(object);

          this.$refs.input.value = "";
        }
      },
    });
  },

  get multipleRegions() {
    return new Set(this.locations.map((location) => location.region)).size > 1;
  },

  get maximumLocations() {
    return this.locations.length >= MAXIMUM_LOCATIONS;
  },

  locationLabel(location) {
    return [location.neighborhood, location.locality, location.place, location.region]
      .filter((x) => x)
      .join(", ");
  },
});
